
import { CLIENT } from "../constant/actionTypes";

export default (state, action) => {
    if (typeof state === 'undefined') {
        state = [];
    }
    switch (action.type) {
        case CLIENT.SOFTWARES.INITIATE:
            return {isFetching: true};
        case CLIENT.SOFTWARES.SUCCESS:
            return {isFetching: false, data: action.payload};
        case CLIENT.SOFTWARES.ERROR:
            return {isFetching: false, data: action.payload};
        default:
            return state;
    }
};
